import { forwardRef } from "react";
import {
  TextField as CoreTextField,
  TextFieldProps as CoreTextFieldProps,
} from "./internal/TextField";
import { MaxLengthCounterProps } from "../../types";

export type TextFieldProps = Omit<CoreTextFieldProps, "prefix"> & {
  prefix?: string;
} & MaxLengthCounterProps;

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  (props, ref) => {
    return <CoreTextField ref={ref} {...props} />;
  },
);

TextField.displayName = "TextField";
